export const FOCUS_AREAS = 'focus-areas';
export const CHAT_PRESETS = 'chat-presets';
